import { z } from 'zod';

export const transactionFlowSchema = z.union([z.literal(1), z.literal(-1)]);
export type TransactionFlow = z.infer<typeof transactionFlowSchema>;
